// extracted by mini-css-extract-plugin
export default {"home":"_1pWdKktNHewhiET7XjQkAB","fixed":"Yyp1wHnJVFJUpTRjHx1wv","coming":"_1x1i6wwkAFz_VEed0941IG"};